import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HighContrastComponent } from './high-contrast.component';

@NgModule({
  declarations: [HighContrastComponent],
  imports: [CommonModule],
  exports: [HighContrastComponent],
})
export class HighContrastModule {}
